import React from 'react'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import Card from "../common/Card";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);

// Radialize the colors



export default function OSRespostasPieChart(prop) {
    const { series, title } = prop;

    let valores = [];

    const b = prop.booleano? true : false;

    if (series) {
        series.map(s => {
            valores.push({
                name: b? ( (s.resposta === "0")? "NAO" : "SIM" ) : s.resposta,
                y: s.contagem,
                description: s.contagem + 'un'});
        })
    }

    const configPie = {

            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie'
            },


            tooltip: {
                pointFormat: ' Percentual: {point.percentage:.1f} %<br>Qtde: {point.y}'
            },
            accessibility: {
                point: {
                    valueSuffix: ''
                }
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    size: '100%',
                    dataLabels: {
                        enabled: true,
                        format: '{point.name}</b>:<br> Percentual: {point.percentage:.1f} %<br> Qtde: {point.y}',
                        connectorColor: 'silver',
                        distance: 10,

                    }
                }
            },

            title: {
                enabled : true,
                text: title
            },
            series: [{
                name: title,
                data: valores
            }]
        }

    return (
        <Card>
            <ReactHighcharts config = {configPie}>
            </ReactHighcharts>
        </Card>
    )
}
